import React, { useCallback } from 'react';

import { dispatchMessage, MessagingEvents } from '@services/messagingService';
import { FATAL_ERROR_VOUCHER_CODE } from '@sharedComponents/Benefits';

import { usePostVoucherAwaitable } from '../../../services';
import { CartActions, ECartActions } from '../model';

export const useAddVoucher = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = usePostVoucherAwaitable();

  return useCallback(
    async (voucherCode: string): Promise<string[]> => {
      const result = await request({ voucher: { code: voucherCode } });

      if (!result) {
        return [FATAL_ERROR_VOUCHER_CODE];
      }

      if (result.data) {
        dispatch({ actionType: ECartActions.UPDATE_VOUCHER, payload: result.data });
        dispatchMessage({ event: MessagingEvents.ECartManipulationEvents.CART_UPDATE_EVENT });
      }

      return result.localizedErrorMessages && result.localizedErrorMessages.length > 0
        ? result.localizedErrorMessages
        : [];
    },
    [request, dispatch],
  );
};
